import { GET_APPOINTMENT_RATING_QUESTIONS } from "./appoinment-rating-ques.query";
import { IAppointmentRatingQuestResponse } from "./appointment-rating.interface";
import { useLazyQuery } from "@apollo/client";

export const useAppointmentRatingQuestions = () => {
  const [fetchQuestions, { data, loading, error }] = useLazyQuery<{fetchQuestions :
     IAppointmentRatingQuestResponse}>(GET_APPOINTMENT_RATING_QUESTIONS);

  const getAppointmentRatingQuestion = ()=>{
    fetchQuestions();
  };

  return {
    getAppointmentRatingQuestion,
    questionsList: data?.fetchQuestions?.questions || [],
    loading,
    error,
  };
};
